module.exports = __webpack_public_path__ + "static/emisoras-4af3ef40bdfb1d660920e6fed333b87f.png";